<template>
  <div id="tjnm">
    <router-view />
  </div>
</template>
<script>
import localforage from "localforage"

export default {
  name: 'App',
  data() {
    return {

    }
  },
  mounted() {
    window.addEventListener("beforeunload", e => this.beforeunloadHandler(e));
  },
  destroyed() {
    window.removeEventListener("beforeunload", e => this.beforeunloadHandler(e));
  },
  methods: {
    beforeunloadHandler(e) {
      console.log('全局注册、全局销毁')
      localforage.clear();
    },
  }
}

</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue